<template>
    <content-view>
        <template #header>
            <div class="home-head">
                <bread-crumb :buttonColor="'#00B4B0'" :activeText="(index + 1) + ' / ' + tabletNews.length"></bread-crumb>
            </div>
        </template>
        
        <template #content>
            <div class="content-wrapper">
                <v-card rounded="xl" elevation="9">
                    <v-img class="news-entry-header-wrapper" :style="{backgroundColor: '#00B4B0'}">
                        <v-card-text class="d-flex news-entry-headline-text justify-center align-center">
                            <v-btn :to="{name: 'newsEntry', params: {newsID: getPreviousNews()}}" class="change-day-button" >
                                <v-icon class="change-day-icon">mdi-menu-left</v-icon>
                            </v-btn>
                            <span style="width: 35vw;">{{news !== undefined ? news.title : ''}}</span>
                            <v-btn :to="{name: 'newsEntry', params: {newsID: getNextNews()}}" class="change-day-button" >
                                <v-icon class="change-day-icon">mdi-menu-right</v-icon>
                            </v-btn>
                        </v-card-text>
                    </v-img>
                    <div class="news-info-text news-wrapper">
                        {{news !== undefined ? news.description : ''}}
                    </div>
                </v-card>
            </div>
        </template>
    </content-view>
</template>
<style lang="scss">
.content-wrapper {
    display: grid;
    grid-template-rows: auto;
    height: 100%;
}
.change-day-button{
    height: 6vh !important;
    width: 4.5vw !important;
    border-radius: 1.2vh !important;
    margin: 0 3vw;
}
.change-day-icon{
    font-size: 8vh !important;
    color: $font-color !important;
}
.news-entry-header-wrapper{
    height: 9vh;
}
.news-entry-headline-text{
    height: 100%;
    text-align: center; //ist für längere Texte zusätzlich notwendig
    font: normal normal bold 3.5vh/6vh 'RobotoRegular' !important;
    letter-spacing: 2px !important;
    color: white !important;
}
.news-info-text{
    margin-top: 1vh;
    font: normal normal normal 3.5vh/6vh 'RobotoRegular' ;
    letter-spacing: 0.57px ;
    color: $font-color;
    overflow-y: scroll;
}
.news-wrapper{
    height: 50vh;
    display: flex;
    flex-grow: 1;
    flex-direction: column;
}
</style>
<script>
export default {
    data() {
        return {
        }
    },
    created() {
        this.$store.dispatch({
            type: 'moduleNews/fetchNews',
        }).catch((error) => {
            if(error.response.status === 401) {
                this.$root.$emit('unauthenticated');
            } else {
                this.apiErrorMessageHandler(error);
            }
        });
    },
    watch: {
        'news': function(news) {
            this.$store.commit({
                type: 'moduleNews/addReadNews',
                news: news
            });
        }
    },
    methods: {
        getPreviousNews() {
            if(this.index === 0) {
                return this.tabletNews[this.tabletNews.length - 1].id;
            } else {
                return this.tabletNews[this.index - 1].id;
            }
        },
        getNextNews() {
            if(this.tabletNews.length === this.index + 1) {
                return this.tabletNews[0].id;
            } else {
                return this.tabletNews[this.index + 1].id;
            }
        }
    },
    computed: {
        tabletNews() {
            return this.$store.getters['moduleNews/tabletNews'];
        },
        news() {
            return this.tabletNews.find((news) => {return news.id === parseInt(this.$route.params.newsID)});
        },
        index() {
            return this.tabletNews.findIndex((news) => {return news.id === parseInt(this.$route.params.newsID)});
        }
    }
}
</script>
